import type { FC } from 'react';
import React, { createContext, useContext } from 'react';

export type AccordionHeading = { headingTitle: string; id: string };

type ContextValue = AccordionHeading | void;

export const AccordionHeaderContext = createContext<ContextValue>(undefined);

export const useAccordionHeaderContext = () => useContext(AccordionHeaderContext);

interface AccordionHeaderProps {
  heading: ContextValue;
  children?: React.ReactNode;
}
export const AccordionHeaderProvider: FC<AccordionHeaderProps> = ({ children, heading }) => (
  <AccordionHeaderContext.Provider value={heading}>{children}</AccordionHeaderContext.Provider>
);
